export * from './IconScreenStroked';
